module.exports = __webpack_public_path__ + "media/images/icons/icn_020-c9b1bf0e1a99db2b0724cfe970de039f.svg";